<template>
  <div class="c-login" v-show="visible">
    <div class="c-login__overlay" @click="close()"></div>
    <div class="c-login__main">
      <h2 class="c-login__title">niet ingelogd</h2>
      <p class="c-login__text">
        {{messageOrDefault}}
      </p>
      <div class="c-login__actions">
        <button @click="close()" class="c-button">ANNULEER</button>
        <button @click="login()" class="c-button">INLOGGEN</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoginNotification',
  data() {
    return {
      visible: false,
      message: ""
    }
  },
  computed: {
    messageOrDefault() {
      return this.message || "Om dit te doen moet je je eerst aanmelden!"
    }
  },
  methods: {
    login() {
      window.location = "/login"
    },
    close() {
      this.visible = false
    }
  },
};
</script>
